<template>
  <ul class="SimplesComponent">
    <li
      v-for="(item, i) in items"
      :key="i"
      class="row"
    >
      <p
        class="text"
        ref="textElements"
        :alt="item.text"
      >
        {{ typeof item === 'string' ? item : item.text }}
      </p>
      <!-- <a
        class="more"
        v-if="isTextTruncated[i]"
      >
        Ver más <BaseTooltip :tooltip="item.text" />
      </a> -->
      <p
        v-if="item?.value"
        class="price"
      >
        {{ item.value }}
      </p>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { nextTick, onMounted, onUnmounted, ref } from 'vue';

// import BaseTooltip from '@/modules/core/components/ui/BaseTooltip.vue'
interface PropsInterface {
  items: any
}

const isTextTruncated = ref<boolean[]>([])
const textElements = ref<(HTMLSpanElement | null)[]>([])

withDefaults(defineProps<PropsInterface>(), {})
const checkTextOverflow = () => {
  nextTick(() => {
    isTextTruncated.value = textElements.value.map((element) => {
      if (element) {
        return element.scrollHeight > element.clientHeight
      }
      return false
    })
  })
}

const handleResize = () => {
  checkTextOverflow()
}
onMounted(() => {
  checkTextOverflow()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style lang="scss" scoped>
.SimplesComponent {
  all: unset;

  .row {
    position: relative;
    padding: $spacing-m;
    color: $color-primary-dark;
    font-size: $font-size-s;
    height: 110px;

    &:nth-child(2n) {
      background-color: $color-primary-lighter;
    }

    .text {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: $font-size-s;
    }

    .more {
      position: relative;
      top: $size-05;
      float: right;
      font-size: $font-size-xs;
      color: $color-primary;
      font-weight: $font-weight-700;
      display: block;
      cursor: pointer;
    }

    .price {
      font-weight: $font-weight-700;
    }
  }
}
</style>
